import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { UserSession, UserSessionCreate, UserSessionFilter } from '../data/userSession';

export function createUserSessionService(client: AxiosInstance) {
  return createCrudService<UserSession, UserSessionCreate, UserSessionFilter>(
    client,
    '/identity/UserSession',
    'id',
  );
}

export type UserSessionService = CrudService<UserSession, UserSessionCreate, UserSessionFilter>;
